(() => {
  const ORIGIN_KEY = "purchase_origin";
  const POPUP_KEY = "fecosur_cooperative_popup_seen";

  const origin = sessionStorage.getItem(ORIGIN_KEY);
  const alreadySeen = sessionStorage.getItem(POPUP_KEY);
  const isProductPage = window.location.pathname.includes("/products/");

  if (origin !== "fecosur" || alreadySeen || !isProductPage) return;
  if (!Array.isArray(window.COOPERATIVES) || !window.COOPERATIVES.length) return;

  let selectedValue = "";

  const popup = document.createElement("div");

  popup.innerHTML = `
    <div class="fecosur-popup-overlay">
      <div class="fecosur-popup">

        <h2>¿De qué cooperativa venís?</h2>

        <p>Seleccioná tu cooperativa para que podamos identificar correctamente el origen de tu inscripción.</p>

        <label class="fecosur-popup__label">Mi Cooperativa</label>

        <button type="button" class="fecosur-popup__confirm">
          Confirmar
        </button>

      </div>
    </div>
  `;

  document.body.appendChild(popup);

  const style = document.createElement("style");
  style.textContent = `
    .fecosur-popup-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,.55);
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2rem;
    }

    .fecosur-popup {
      position: relative;
      background: #fff;
      color: #1c3844;
      width: min(92vw, 560px);
      padding: 4rem;
      border: 1px solid #d9d9d9;
      border-radius: 17px;
      text-align: center;
      box-shadow: 0 24px 60px rgba(0,0,0,.22);
    }

    .fecosur-popup__close {
      position: absolute;
      top: 1.4rem;
      right: 1.6rem;
      background: transparent;
      border: 0;
      font-size: 3.2rem;
      line-height: 1;
      cursor: pointer;
      color: #1c3844;
    }

    .fecosur-popup h2 {
      margin: 0 0 1rem;
      color: #1c3844;
      font-size: clamp(2.4rem, 3vw, 3.4rem);
      font-weight: 800;
    }

    .fecosur-popup p {
      margin: 0 0 2.8rem;
      font-size: 1.6rem;
      line-height: 1.5;
      color: #1c3844;
    }

    .fecosur-popup__label {
      display: block;
      text-align: left;
      margin-bottom: .8rem;
      font-weight: 700;
      color: #333;
    }

    .fecosur-popup__confirm {
      width: 100%;
      margin-top: 2.4rem;
      padding: 1.4rem;
      border: 0;
      border-radius: 8px;
      background: #1c3844;
      color: #fff;
      font-weight: 700;
      cursor: pointer;
      font-size: 1.6rem;
    }

    .fecosur-popup__confirm:hover {
      background: #43a047;
    }

    .fecosur-popup__skip {
      margin-top: 1.4rem;
      background: transparent;
      border: 0;
      color: #1c3844;
      cursor: pointer;
      font-weight: 600;
    }

    @media (max-width: 749px) {
      .fecosur-popup {
        padding: 3rem 2rem;
      }
    }
  `;
  document.head.appendChild(style);

  const selectorContainer = document.createElement("div");

  popup
    .querySelector(".fecosur-popup__label")
    .after(selectorContainer);

  window.createCooperativeSelector({
    container: selectorContainer,
    onSelect(value) {
      selectedValue = value;
    },
  });

  popup.querySelector(".fecosur-popup__confirm").addEventListener("click", () => {
    if (!selectedValue) return;

    sessionStorage.setItem(ORIGIN_KEY, selectedValue);
    document.dispatchEvent(new Event("purchase-origin:changed"));
    
    sessionStorage.setItem(POPUP_KEY, "1");
    popup.remove();
  });
})();